<template>
  <el-dialog title="批量修改" :visible.sync="batchUpdateDialog" width="1000px">
    <div style="overflow:auto;height: 500px">
      <div style="border-left: #b0b0b1 2px solid;margin-left: 60px;">
        <div style="margin: 30px">
          <div class="step-number">1</div>
          <div>假期类型：
            <el-select v-model="choiceRules" multiple placeholder="请选择">
              <el-option v-for="(item,index) in holidayRules" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <div style="margin: 30px">
          <div class="step-number">2</div>
          <div>下载批量修改的Excel模板：
            <el-button type="danger" @click="exportHolidayRemaining()"> 下载模版 </el-button>
          </div>
        </div>
        <div style="margin: 30px">
          <div class="step-number">3</div>
          <div >
            在模板中输入修改后的余额
            <div style="margin-left: 16px;color: #b0b0b1">
              <div style="margin-top: 4px">说明：</div>
              <div style="margin-left: 18px">1、历史（不包括本年）有效余额全部清空，变成0</div>
              <div style="margin-left: 18px">2、当前年额度变更为表格导入的额度，流水为两者的差值</div>
              <div style="margin-left: 18px">3、流水记录有2条，1条是清空历史额度，1条是本年度余额调整</div>
              <div style="margin-top: 4px">示例：</div>
              <el-image :src="require('/src/assets/image/explain.png')" ></el-image>
            </div>
          </div>
        </div>
        <div style="margin: 30px">
          <div class="step-number">4</div>
          <div style="">
            上传文件：
            <el-upload :auto-upload="false" action=" " drag :limit="1" :on-change="changeFile" style="margin: 20px 0 0 60px">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </div>
        </div>
        <div style="margin: 30px">
          <div class="step-number">5</div>
          <div style="padding: 20px 0 30px 0">
            确定批量修改：<el-button type="danger" @click="importResetHolidayBalance()">确 定</el-button>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: right; margin: 30px 20px 10px 0">
      <el-button @click="batchUpdateDialog = false">取 消</el-button>
      <el-button type="danger" @click="importResetHolidayBalance()">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {selectHolidayRules,exportHolidayRemaining,importResetHolidayBalance} from '/src/api/attendance/holiday'
export default {
  name: "BatchUpdate",
  data() {
    return {
      holidayRules:[],
      choiceRules:[],
      uploadFile:null,
      batchUpdateDialog:false
    }
  },
  methods: {
    openDialog() {
      this.batchUpdateDialog = true;
    },
    changeFile(file) {
      this.uploadFile = file.raw;
    },
    exportHolidayRemaining(){
      if (this.choiceRules.length < 1){
        this.$message.warning('请选择假期类型！');
        return;
      }
      let item = {'holidayRulesIds':this.choiceRules};
      exportHolidayRemaining(item).then(val=>{
        if (val.status == 200){
          let url = val.data;
          window.URL = window.URL || window.webkitURL;
          var name = url.substring(url.lastIndexOf("/") + 1, url.length);
          var xhr = new XMLHttpRequest();
          var a = document.createElement("a");
          xhr.open("GET", url, true);
          xhr.responseType = "blob";
          xhr.onload = function() {
            var file = new Blob([xhr.response], { type: "application/octet-stream" });
            a.href = window.URL.createObjectURL(file);
            a.download = name;
            a.click();
          };
          xhr.send();
        }
      })
    },
    importResetHolidayBalance(){
      if (this.uploadFile == null){
        this.$message.warning('请选择文件！');
        return;
      }
      const formData = new FormData();
      formData.append('file', this.uploadFile);

      importResetHolidayBalance(formData).then(val=>{
        this.uploadFile = null;
        this.batchUpdateDialog = false;
        this.$message.success('导入成功！');
      })
    }
  },
  created() {
    selectHolidayRules().then(val => {
      if (val.status == 200){
        console.log(val.data)
        this.holidayRules = val.data;
      }
    })
  }
}
</script>

<style scoped>
.step-number{
  position: relative;left: -45px;border: #b0b0b1 1px solid;
  height: 26px;width: 26px;border-radius: 50%;text-align:center;
  background-color: white;line-height: 26px;
}

</style>